import React from 'react';
import {
  Select,
  FormControl,
  FormLabel,
  HStack,
  Spinner
} from '@chakra-ui/react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSelector = ({ size = 'md', showLabel = true, variant = 'outline', onChange }) => {
  const { currentLanguage, supportedLanguages, loading, changeLanguage, t } = useLanguage();

  const handleLanguageChange = (event) => {
    const newLanguage = event.target.value;
    if (onChange) {
      onChange(newLanguage);
    } else {
      changeLanguage(newLanguage);
    }
  };

  return (
    <FormControl>
      {showLabel && (
        <FormLabel fontSize={size === 'sm' ? 'sm' : 'md'}>
          {t('settings.language.select')}
        </FormLabel>
      )}
      <HStack spacing={2}>
        <Select
          value={currentLanguage}
          onChange={handleLanguageChange}
          size={size}
          variant={variant}
          isDisabled={loading}
          minW="150px"
        >
          {supportedLanguages.map((lang) => (
            <option key={lang.code} value={lang.code}>
              {t(`language.${lang.code}`, { defaultValue: lang.name })}
            </option>
          ))}
        </Select>
        {loading && <Spinner size="sm" />}
      </HStack>
    </FormControl>
  );
};

export default LanguageSelector;
